import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit() {}

  

  openFeedback(event: Event): void {
    event.preventDefault();
    // TODO: Implement feedback functionality if needed
    console.log('Feedback link clicked');
  }

  signIn(): void {
    this.authService.isLoginInProgress = false;
    this.authService.signOut(false)
    // this.authService.signIn();
  }

}
